var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.watch),expression:"watch"}]},[_c('svg',{ref:"gantt",attrs:{"id":"gantt"}})])}
var staticRenderFns = []
export { render, staticRenderFns }